import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';


const SearchAndFilters = ({
  searchTerm,
  onSearchChange,
  filters,
  onFilterChange,
  onClearFilters,
  totalResults,
  roleCounts = {}
}) => {
  const roleOptions = [
    { value: '', label: 'Todos os perfis' },
    { 
      value: 'admin', 
      label: `Admin ${roleCounts?.admin ? `(${roleCounts?.admin})` : ''}` 
    },
    { 
      value: 'manager', 
      label: `Gestor ${roleCounts?.manager ? `(${roleCounts?.manager})` : ''}` 
    },
    { 
      value: 'viewer', 
      label: `Leitor ${roleCounts?.viewer ? `(${roleCounts?.viewer})` : ''}` 
    }
  ];

  const statusOptions = [
    { value: '', label: 'Todos os status' },
    { value: 'active', label: 'Ativo' },
    { value: 'inactive', label: 'Inativo' }
  ];

  const lastLoginOptions = [
    { value: '', label: 'Qualquer período' },
    { value: 'today', label: 'Hoje' },
    { value: 'week', label: 'Esta semana' },
    { value: 'month', label: 'Este mês' },
    { value: 'never', label: 'Nunca acessou' }
  ];

  const hasActiveFilters = filters?.role || filters?.status || filters?.lastLoginRange || searchTerm;

  return (
    <div className="bg-white rounded-lg border border-border shadow-sm p-6 mb-6">
      {/* Search Bar */}
      <div className="mb-6">
        <div className="relative max-w-md">
          <Input
            type="text"
            placeholder="Busque usuários por nome ou e-mail..."
            value={searchTerm}
            onChange={(e) => onSearchChange?.(e?.target?.value)}
            className="pl-10"
          />
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg className="h-4 w-4 text-muted-foreground" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
        </div>
      </div>
      {/* Filters */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Filtrar por perfil
          </label>
          <Select
            value={filters?.role}
            onValueChange={(value) => onFilterChange?.('role', value)}
            placeholder="Selecione o perfil..."
          >
            {roleOptions?.map((option) => (
              <Select.Item key={option?.value} value={option?.value}>
                {option?.label}
              </Select.Item>
            ))}
          </Select>
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Filtrar por status
          </label>
          <Select
            value={filters?.status}
            onValueChange={(value) => onFilterChange?.('status', value)}
            placeholder="Selecione o status..."
          >
            {statusOptions?.map((option) => (
              <Select.Item key={option?.value} value={option?.value}>
                {option?.label}
              </Select.Item>
            ))}
          </Select>
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Último acesso
          </label>
          <Select
            value={filters?.lastLoginRange}
            onValueChange={(value) => onFilterChange?.('lastLoginRange', value)}
            placeholder="Selecione o período..."
          >
            {lastLoginOptions?.map((option) => (
              <Select.Item key={option?.value} value={option?.value}>
                {option?.label}
              </Select.Item>
            ))}
          </Select>
        </div>

        <div className="flex items-end">
          <Button
            variant="outline"
            onClick={onClearFilters}
            disabled={!hasActiveFilters}
            className="w-full"
            iconName="X"
            iconPosition="left"
          >
            Limpar filtros
          </Button>
        </div>
      </div>
      {/* Results Summary */}
      <div className="flex items-center justify-between text-sm text-muted-foreground border-t border-border pt-4">
        <div>
          Exibindo <span className="font-medium text-foreground">{totalResults || 0}</span> usuários
          {hasActiveFilters && (
            <span className="ml-1">
              (filtrados)
            </span>
          )}
        </div>

        {hasActiveFilters && (
          <div className="flex items-center space-x-2">
            <span>Filtros ativos:</span>
            <div className="flex items-center space-x-1">
              {searchTerm && (
                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800">
                  Busca: "{searchTerm}"
                </span>
              )}
              {filters?.role && (
                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-green-100 text-green-800">
                  Perfil: {filters?.role}
                </span>
              )}
              {filters?.status && (
                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-orange-100 text-orange-800">
                  Status: {filters?.status}
                </span>
              )}
              {filters?.lastLoginRange && (
                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-purple-100 text-purple-800">
                  Acesso: {filters?.lastLoginRange}
                </span>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchAndFilters;